<template>
<div class="chapter">
<div class="inner_page">
<h1>101 Things to Do with Pudding</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Helpful Hints </a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">Rolls, Breads, &amp; Muffins </a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Fruit Salads</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Cookies, Brownies, &amp; Bars,</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Pies &amp; Pudding Squares</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Cakes</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Family Favorites</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Dazzling Desserts</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?1f0ffdba